import {configTC} from "../../constant/initDrawing";
import MainTCWrapper from "../../components/live2/tc/MainTCWrapper";

const config = {
    ...configTC,
    type: "vnone"
}

const Live2MCBlackPage = () => {
    return <MainTCWrapper config={config}/>
}

export default Live2MCBlackPage;